export type FormatType = "Excel" | "PDF";

export const downloadFile = (
  fileData: BlobPart | Blob,
  formatType: string,
  fileName: string
) => {
  try {
    const isFile = fileData instanceof File;

    const blob =
      fileData instanceof Blob
        ? fileData
        : new Blob([fileData], {
            type:
              formatType === "Excel"
                ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                : "application/pdf",
          });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    const extension = formatType === "Excel" ? "xlsx" : "pdf";

    // ✅ USE BLOB / FILE NAME IF AVAILABLE
    const baseName =
      isFile && fileData.name
        ? fileData.name.replace(/\.[^/.]+$/, "") // remove extension
        : "download";

    const timestamp = getReadableTimestamp();

    link.download = `${fileName || baseName}-${timestamp}.${extension}`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Download error:", err);
    throw new Error("Failed to download the file. Please try again.");
  }
};

const getReadableTimestamp = () => {
  const d = new Date();

  const date = d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const time = d
    .toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/:/g, "-");

  return `${date.replace(/ /g, "-")}_${time}`;
};
